import React, { useEffect, useState } from 'react'
import './App.css'
import { RouterProvider } from 'react-router-dom'
import { routerDeleverItems } from './router'
import 'normalize.css'
import CartElemInfoModal from './pages/components/ModalWindows/CartElemInfoModal/CartElemInfoModal'
import Footer from "./pages/components/Footer/Footer";
import { useSelector } from 'react-redux'
import FavoriteModal from './pages/components/ModalWindows/FavoriteModal/FavoriteModal'
import AutoDataSynhronaizer from './pages/components/AutoDataSynhronaizer/AutoDataSynhronaizer'
import ItemCardModal from './pages/components/ModalWindows/ItemCardModal/ItemCardModal'
import WarningModal from './pages/components/ModalWindows/WarningModal/WarningModal'
import AlertModal from './pages/components/ModalWindows/AlertModal/AlertModal'
import ErrorHandler from './pages/ErrorPage/ErrorHandler'
import useSendLog from './hooks/useSendLog'
import { HelmetProvider } from 'react-helmet-async';
import SalesAlert from './pages/components/SalesAlert/SalesAlert'


const App = () => {
  const openFavoriteModal = useSelector(state => state.contextUI.uiModal.favoriteModal)
  const ItemModalData = useSelector(state => state.contextUI.uiModal.itemModal)
  const [isAlertModal, setIsAlertModal] = useState(true)
  const [isSaleAlertModal, setIsSaleAlertModal] = useState(true)
  const sendUserStats = useSendLog('User stats', { 
    device: navigator.userAgent,
    typeOfDevice: navigator.platform,
    os: navigator.oscpu,
    browser: navigator.appName,
    browserVersion: navigator.appVersion
  });

  // window.addEventListener('load', function(event) {
    console.log("auto deploy is work 2.0")
  //   sendUserStats()
  // });

  return (
    <div className='App'>
      <ErrorHandler>
        <HelmetProvider>
          <div className='App__padding'>
            <RouterProvider router={routerDeleverItems} />
            
            {openFavoriteModal && <FavoriteModal/>}
            <CartElemInfoModal/>
            
            {/* {isAlertModal && 
            <AlertModal closeFunc={setIsAlertModal} sx={{ textAlign: 'start ', fontSize: '13px'}}>
              <div style={{width: '100%', borderRadius: '8px', overflow: 'hidden'}}>
                <img src={'https://i.imgur.com/pnki7L4.png'} style={{width: '100%'}}/>
              </div><br/>
              Estimados clientes y amigos:<br/>
              <br/>
              Les informamos que el servicio previsto para mañana estará sujeto a la evolución de la situación de alerta de Protección Civil.<br/>
              <br/>
              <b>Durante la mañana tomaremos una decisión definitiva sobre la realización del servicio y sus posibles limitaciones</b>, teniendo en cuenta las condiciones meteorológicas actuales. <br/>
              <br/> 
              Lamentamos los inconvenientes que esta situación pueda ocasionar y agradecemos su comprensión.<br/>
              <br/>
              Atentamente,<br/>
              TPO -Tú Producto Online<br/>
            </AlertModal>} */}
            <AutoDataSynhronaizer/>
            {isSaleAlertModal && <SalesAlert closeFunc={setIsSaleAlertModal}/>}
            {ItemModalData.isShow ? <ItemCardModal card={ItemModalData.item}/> : <></>}
          </div>
        </HelmetProvider>
      </ErrorHandler>
        <Footer/>
    </div>
  )
}

export default App